import cn from 'clsx';
import React from 'react';

import { useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

interface IContainerInnerProps {
  children: React.ReactNode | null;
  variant?: 'default' | 'scrollArea';
}

export const ContainerInner: React.FC<IContainerInnerProps> = props => {
  const { children, variant = 'default' } = props;
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['content'], variant === 'scrollArea' && styles['scroll-area'], styles[deviceType])}>
      {children}
    </div>
  );
};
